<h1 class="top-bar__title">
  {{ videoTitle() }}
</h1>
<img class="top-bar__logo" src="assets/logo-ministerie-van-defensie.svg" alt="Logo Ministerie van Defensie" />
